import React, { useEffect } from "react";
import PageBreadcrumbs from "../SharedComponent/page-breadcrumbs";
import HomeMainServices from "../component/Home/HomeMainServices";
import HomeResults from "../component/Home/HomeResults";
import HomeServices from "../component/Home/HomeServices";
import HomeTrusted from "../component/Home/HomeTrusted";
import HomeFinancialSolutions from "../component/Home/HomeFinancialSolutions";
import HomeSloganCards from "../component/Home/HomeSloganCards.jsx";
import HomeFaq from "../component/Home/HomeFaq.jsx";
import HomeBrands from "../component/Home/HomeBrands.jsx";
import ContactUs from "../component/Home/ContactUs.jsx";
import HomeHero from './../pages/home/home-hero.jsx'

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <HomeHero/>
      <HomeMainServices />
      <HomeResults />
      <HomeServices />
      <HomeTrusted />
      <HomeFinancialSolutions />
      <HomeSloganCards />
      <HomeFaq />
      <HomeBrands />
      <ContactUs />
    </div>
  );
};

export default Home;
